import { ref } from 'vue';
import { AGREED_PRIVACY_KEY } from '@/enums/cacheEnum';
import { isWorkbenchMode } from '@/project';
import { Storage } from '@/utils/storage';

/** 隐私弹窗状态：agreed=已同意（或非 iOS 包，无需弹窗）、pending=待用户选择、declined=已拒绝 */
export const privacyStatus = ref<'agreed' | 'pending' | 'declined'>('agreed');

/** 当前变体是否需要首启隐私同意（仅 iOS 工作台包；Android 走 DCloud 原生弹窗 androidPrivacy.json） */
export function needPrivacyConsent(): boolean {
  return isWorkbenchMode();
}

/** 是否已同意（持久化标记，永不过期） */
export function hasAgreedPrivacy(): boolean {
  return Storage.get<boolean>(AGREED_PRIVACY_KEY, false) === true;
}

/** App onLaunch 调用：确定初始状态（未同意则 pending，由 App.ku.vue 渲染弹窗） */
export function initPrivacyGate(): void {
  privacyStatus.value = needPrivacyConsent() && !hasAgreedPrivacy() ? 'pending' : 'agreed';
}

let resolveConsent: (() => void) | null = null;

/**
 * 业务初始化闸门：iOS 包首启未同意时挂起（弹窗由 App.ku.vue 渲染），
 * 直到用户点「同意并接受」后 resolve；拒绝路径退出 App，Promise 不再被消费。
 * 非 iOS 包 / 已同意：立即返回。
 */
export function waitForPrivacyConsent(): Promise<void> {
  if (privacyStatus.value === 'agreed') return Promise.resolve();
  return new Promise<void>((resolve) => {
    resolveConsent = resolve;
  });
}

/** 用户点「同意并接受」 */
export function agreePrivacy(): void {
  Storage.set(AGREED_PRIVACY_KEY, true, null); // 传 null 永不过期：默认 7 天过期会导致弹窗复现
  privacyStatus.value = 'agreed';
  resolveConsent?.();
  resolveConsent = null;
}

/** 用户点「不同意」：App 端直接退出；H5 预览降级为提示并保持弹窗，避免开发环境卡死 */
export function declinePrivacy(): void {
  // #ifdef APP-PLUS
  privacyStatus.value = 'declined';
  plus.runtime.quit();
  // #endif
  // #ifndef APP-PLUS
  uni.showToast({ title: '需同意后才能继续使用', icon: 'none' });
  // #endif
}
